/**
 * Semi-circle SVG readiness gauge (0-100) with brand fill.
 */
export default function ReadinessGauge({ value = 0, size = 220, label = "Beginning" }) {
  const v = Math.max(0, Math.min(100, value));
  const stroke = 14;
  const r = (size - stroke) / 2;
  const cx = size / 2;
  const cy = size / 2;
  // Semi-circle arc length: π * r
  const circumference = Math.PI * r;
  const offset = circumference * (1 - v / 100);

  return (
    <div className="flex flex-col items-center" data-testid="readiness-gauge">
      <svg width={size} height={size / 2 + 12} viewBox={`0 0 ${size} ${size / 2 + 12}`}>
        <path
          d={`M ${stroke / 2} ${cy} A ${r} ${r} 0 0 1 ${size - stroke / 2} ${cy}`}
          fill="none"
          strokeWidth={stroke}
          className="gauge-track"
          strokeLinecap="round"
        />
        <path
          d={`M ${stroke / 2} ${cy} A ${r} ${r} 0 0 1 ${size - stroke / 2} ${cy}`}
          fill="none"
          strokeWidth={stroke}
          className="gauge-fill"
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
        />
      </svg>
      <div className="mt-[-32px] text-center">
        <div className="font-display text-5xl font-bold tracking-tight" data-testid="readiness-value">{v}</div>
        <div className="overline mt-1">{label}</div>
      </div>
    </div>
  );
}
